import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useModalManager } from '../../hooks/ModalManager.hook';
import useEmailTemplate from '../../hooks/useEmailTemplate.hook';
import { useAppSelector } from '../../hooks/useAppSelector.hook';
import ButtonComponent from '../Button.component';
import BaseModalComponent from './BaseModal.component';
import { SelectOptionProps } from '../Input/Select.component';
import { getUserEmailTemplates } from '../../redux/User/UserSlice';
import { RoutesConstant } from '../../constants/routes.constant';
import {
  EventStatus,
  EventStatusCode,
} from '../../redux/Event/Status/EventStatus.type';

// При этих статусах покажем окно отправки шаблона через почтовый клиент
export const REPLY_WHEN_STATUSES = [
  EventStatusCode.PRE_INTERVIEW_REJECT,
  EventStatusCode.INTERVIEW_REJECT,
  EventStatusCode.COMMUNICATION_REJECT,
] as string[];

export const GOOGLE_CALENDAR_EVENT_WHEN_STATUSES = [
  EventStatusCode.PRE_INTERVIEW_PLANNED,
  EventStatusCode.INTERVIEW_PLANNED,
];

interface Props extends React.AllHTMLAttributes<HTMLDivElement> {
  status?: SelectOptionProps | EventStatus;
}

const StyledButtonsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: end;
  gap: 10px;
`;

const StyledMessage = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  white-space: pre-wrap;
  margin-bottom: 10px;
`;

const ReplyToCandidateModal = ({ status }: Props) => {
  const { closeModal } = useModalManager();
  const { t } = useTranslation();
  const emailTemplates = useAppSelector(getUserEmailTemplates);

  const getEmailTemplateText = (
    status?: SelectOptionProps | EventStatus,
  ): string => {
    if (!status || emailTemplates.length === 0) {
      return '';
    }

    const template = emailTemplates.find(
      template => template.code === status.code,
    );

    return template?.template || '';
  };

  const { openMailClient } = useEmailTemplate({
    templateText: getEmailTemplateText(status),
  });

  const redirectToProfile = () => {
    window.open(RoutesConstant.PROFILE);
  };

  return (
    <BaseModalComponent
      header={t('answerToCandidate')}
      onCrossButtonClick={closeModal}
    >
      <StyledMessage>{t('youWillBeRedirectedToYourEmailClient')}</StyledMessage>

      <StyledMessage>
        {t('templateTextCanBeChangedInProfile')}

        <ButtonComponent handleClick={redirectToProfile} btnSize={'small'}>
          {t('goToProfile')}
        </ButtonComponent>
      </StyledMessage>

      <StyledButtonsContainer>
        <ButtonComponent handleClick={closeModal}>{t('Close')}</ButtonComponent>

        <ButtonComponent appearance="primary" handleClick={openMailClient}>
          {t('Send')}
        </ButtonComponent>
      </StyledButtonsContainer>
    </BaseModalComponent>
  );
};

export default ReplyToCandidateModal;
